// extracted by mini-css-extract-plugin
export default {"textReminder":"TextReminder_textReminder__4wPdS","label":"TextReminder_label__gbLhH","icon":"TextReminder_icon__6lUUN"};